/**
 *
 * @param {Object} params
 * @param {string} params.title
 * @param {string} params.description
 * @param {string} params.keywords
 * @param {string | null} params.image
 * @param {string | null} params.url
 * @param {string} params.appTitle
 * @param {string} params.appCountKey
 * @param {string} params.iconUrl
 * @param {string} params.iconGrayUrl
 * @param {string} params.iconSettingUrl
 */
export const useCommonHead = (params) => {
  const config = useRuntimeConfig()
  const route = useRoute()
  const pageUrl = params.pageUrl ?? `${config.public.hostDomain}${config.app.baseURL}${route.path.replace(/^\//, '')}`
  const image = params.image ? params.image : 'https://gvs.weathernews.jp/common/images/ogp/world-weather@1x.png'

  useSeoMeta({
    title: params.title,
    ogTitle: params.title,
    description: params.description,
    ogDescription: params.description,
    keywords: params.keywords,
    ogImage: image,
    twitterCard: 'summary_large_image',
    twitterSite: '@wni_jp',
    twitterCreator: '@wni_jp',
    fbAppId: '1500388770270212',
    appleItunesApp: { appId: '302955766' },
    mobileWebAppCapable: 'yes'
  })

  useHead({
    link: [
      { rel: 'canonical', href: pageUrl },
      { rel: 'icon', type: 'image/x-icon', href: 'https://gvs.weathernews.jp/favicon.ico' },
      { rel: 'dns-prefetch', href: 'https://gvs.weathernews.jp' },
      { rel: 'preconnect', href: 'https://gvs.weathernews.jp', crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: 'https://site.weathernews.jp' },
      { rel: 'preconnect', href: 'https://site.weathernews.jp', crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: 'https://gis.weathernews.jp' }
    ],
    meta: [
      { name: 'wntouch_enable', content: 'yes' },
      { name: 'wntouch_ch', content: '世界天気' },
      { name: 'wntouch_title', content: params.appTitle },
      { name: 'wntouch_count', content: `world_weather:${params.appCountKey}` },
      { name: 'wntouch_icon', content: params.iconUrl },
      { name: 'wntouch_icon_gray', content: params.iconGrayUrl },
      { name: 'wntouch_icon_setting', content: params.iconSettingUrl },
      { name: 'wntouch_url', content: pageUrl },
      { name: 'viewport', content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes' }
    ],
    htmlAttrs: {
      lang: 'ja'
    }
  })
}
